<template>
<div>
    <div class="m-mailSide">
        <div class="title">
            <p class="title_part1">消息中心</p>
            <p class="title_part2">您有<span>{{ newMsg }}</span>条信息或通知未读!</p>
        </div>
        <div  class="scollbar" v-loading="loading">
            <div v-if="mailList.length">
                <div v-for="(item,index) in mailList" :key="index" class="mainContent"  @click="goDetail(item.id)">
                     <el-tooltip class="item" popper-class="mail-tooltip" effect="light" placement="left-end" :disabled="!item.messageContent">
                        <div slot="content" v-html="item.messageContent"></div>
                        <div>
                            <div class="msg-title">
                                <span >{{ item.messageTitle }}</span>
                                <span class="newIcon" v-if="item.readStatus != 1"></span>
                            </div>
                            <div class="mainContent_content ellipsis-basic"  :style="{color:item.readStatus ? '#969899' : '#303233'}">{{ item.messageContent }}</div>
                        </div>
                    </el-tooltip>
                    <!-- <div class="mainContent_bottom">
                        <span>{{item.messageType == 10 ? '新增订单消息' : item.messageType == 20 ? '新增退款消息' : '审核消息'}}</span>
                    </div> -->
                </div>
                <div class="bottomPart" 
                    v-loading="loadingmore"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading">
                </div>
                <div v-if="isAll" class="nomsg nomsg1">没数据了哦~</div>
            </div>
            <div v-else  class="nomsg">
                <p>暂无消息</p>
            </div>
        </div>
    </div>
    <div class="cover" @click="hide"></div>
</div>
</template>

<script>
import API from '@/fetch/api'
import {GetInfo}  from '@/fetch/com'
import * as access from '@/config/access';


export default {
    props:[],
    data(){
        return{
            loadingmore: false,
            loading: false,
            forms: {
                pageNumber: 1,
                pageSize: 50,
                parkId: access.session('projectId'),
            },
            mailList: [],
            newMsg: 0,
            total: 0,
            newFlag: access.session('newFlag'),
        }
    },
    mounted(){
        let vm = this;
        // 查询消息
        vm.queryMsgs('loading');
        vm.queryMsgCount();
        // 
        let el = document.querySelector('.scollbar'),
            offsetHeight = el.offsetHeight;
        el.onscroll = () => {
            let scrollTop = el.scrollTop,
                scrollHeight = el.scrollHeight;
            if ((offsetHeight + scrollTop) - scrollHeight >= -1) {
                if(!this.isAll){
                    vm.forms.pageSize += vm.forms.pageSize;
                    vm.queryMsgs('loadingmore');
                }
            }
        };
    },
    computed: {
        isAll(){
            return !(this.forms.pageNumber * this.forms.pageSize < this.total)
        }
    },
    methods:{
        hide(){
            this.$emit('hide')
        },
        goDetail(id){
            let vm = this;
            // 跳转到详情
            // vm.$router.push({name: newFlag == 1 ? 'index' : 'index', query:{ id:item.id }});
            // vm.$emit('hide');
            API.http({ url: '/merchant/message/read', type: 'post',
                params: {
                    messageId: id
                }
            }).then(res => {
                if (res.code == 200) {
                    vm.queryMsgs();
                    return;
                }
            })
            
        },
        
        // 查询消息 
        queryMsgs(loading){
            let vm = this;
            vm[loading] = true;
            API.http({ url: '/merchant/message/list', type: 'post',
                params: vm.forms
            }).then(res => {
                vm[loading] = false;
                if (res.code == 200) {
                    const data = res.data.dataList || []
                    data.forEach((item, i)=>{
                        if(item.messageContent){
                            data[i].messageContent = item.messageContent.replace(/\n/g, "<br/>")
                        }
                    })
                    vm.mailList = data;
                    vm.total = res.data.total;
                    return;
                }
            })
        },
        // 查询消息数量 /merchant/message/count
        queryMsgCount(){
            let vm = this;
            API.http({ url: '/merchant/message/count', type: 'post',
                params: {
                    parkId: access.session('projectId') || '',
                }
            }).then(res => {
                if (res.code == 200) {
                    vm.newMsg = res.data.total || 0;
                    return;
                }
            })
        },
    }
}
</script>

<style lang="scss">
@import '../style/variable';
.m-mailSide{
    .scollbar::-webkit-scrollbar {/*滚动条整体样式*/
        width: 5px;     /*高宽分别对应横竖滚动条的尺寸*/
        background: rgba(0,0,0,0.2);
    }
    .scollbar::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        background: rgba(0,0,0,0.2);
        border-radius:inherit;
        height: 5px;
    }
    .scollbar::-webkit-scrollbar-track {/*滚动条里面轨道*/
        background: #fff;
        border-radius:inherit
    }
    .bottomPart .el-loading-spinner i,.el-loading-text{
        color:$c4;
    }
}
</style>

<style lang="scss" scoped>
@import '../style/variable';
.cover{
    position: fixed;top:0;left:0;bottom:0;right:0;background:rgba(0,0,0,.2);z-index:998;
    cursor: pointer;
}
.m-mailSide{
        width: 262px;
        position: fixed;
        top:0px;
        right: 0;
        bottom:0;
        z-index:999;
        padding-top: 170px;
        .scollbar{
            background:#fff;overflow:auto;
            position: absolute;
            top:98px;left:0;right:0;bottom:0;
            .msg-title{
                cursor: pointer;
                display: inline-block;
                font-size: 13px;
                margin-right: 5px;
                .newIcon{
                    background-color: $c4;
                    border-radius: 50%;
                    float: right;
                    height: 5px;
                    margin-top: 6px;
                    margin-left: 4px;
                    width: 5px;
                }

            }
            .mainContent{
                height: 60px;
                padding: 20px;
                box-shadow: inset 0px 1px 0px 0px #e7eaec;
                cursor: pointer;
                &:first-child{
                    box-shadow: none;
                }
                &_content{
                    font-size: $fs_12;
                    margin:15px 10px 15px 0;
                    
                }
                &_bottom{color: #969899;font-size: 12px};
            }
        }
        .title{
            position: absolute;
            top:0;right:0;left: 0;
            height: 78px;
            background-color: #f9f9f9;
            box-shadow:inset 0 -1px 0 0 #e7eaec;
            .title_part1{cursor: pointer;;font-size:22px;color:$c4;i{margin-left:5px;color:$c4;font-size:12px;vertical-align:middle;}};
            .title_part2{margin-top:8px;font-size:12px;color: #676a6c;span{color:$c4}};
            padding:20px 0 0 20px;
        }
        .nomsg{
            color: #969899;font-size:14px;text-align:center;margin-top:20px;
            &.nomsg1{
                color:$c4;font-size:12px;margin:0 0 5px 0;
            }
        }
        
}
</style>
